import React, { useEffect, useRef } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import componentStyles from 'assets/theme/layouts/auth.js'

import Login from 'scenes/guest/Login'
import WebsiteVerification from 'scenes/guest/WebsiteVerification'
import Register from 'scenes/guest/Register'
import AddCard from 'scenes/guest/AddCard'

const useStyles = makeStyles(componentStyles)

const Main = () => {
    const mainContent = useRef(null)

    return (
        <>
            <div className='main-content guest' ref={mainContent}>
                <Switch>
                    <Route exact path='/website-verification' component={WebsiteVerification} />
                    <Route exact path='/register' component={Register} />
                    <Route exact path='/add-card/:token' component={AddCard} />
                    <Route exact path='/' component={Login} />
                    <Redirect from='*' to='/' />
                </Switch>
            </div>
        </>
    )
}

export default Main